import connectAction from 'lib/common/utils/connectAction';
import connectGetter from 'lib/common/utils/connectGetter';

export default function addTransferConnection(contact: connect.Contact, endpoint: connect.Endpoint) {
  return connectAction('addConnection', contact, endpoint, {
    ignoreError: () => connectGetter(contact, 'getState')?.type === connect.ContactStateType.ENDED,
  });
}
